/**
 * Personal Access Token (PAT) scopes.
 *
 * A scope is the unit of authorisation a PAT carries. It is *additive*
 * on top of role-based access (`requireRole`): the `requireScope`
 * middleware only constrains PAT callers — Clerk/cron/recorder/local-lab
 * callers keep their existing role-based behaviour untouched. A PAT must
 * therefore satisfy BOTH the route's `requireRole` (via the issuer's
 * snapshotted role) AND its `requireScope`.
 *
 * Scopes:
 *   - `ideation:write` — the v1 use case (capture an idea note from a CLI);
 *                        also gates the MCP capture tools.
 *   - `notes:write`    — the broader scope, reserved for a future CLI that
 *                        writes non-idea notes. Defined now so the registry
 *                        is stable; only `ideation:write` is lit on a route
 *                        in v1.
 *   - `files:write`    — MCP working-document mutations (create folder/file /
 *                        create+register working document, adopt, revise,
 *                        comment on SharePoint-located working documents).
 *                        A PAT holding this scope is the standing confirm for
 *                        those tools — there is no per-call confirm UX on the
 *                        MCP path, so the scope is the deliberate grant
 *                        (ADR-0102 + create surface).
 *   - `graph:write`    — MCP *structured* graph mutations (upsert_node,
 *                        upsert_edge, supersede_node, supersede_fact —
 *                        ADR-0109 / ADR-0123). Deliberately
 *                        NOT `ideation:write`: that scope grants queued,
 *                        human-reviewed captures, whereas this one grants
 *                        deterministic writes that land immediately. Device
 *                        and cost authority is therefore grantable and
 *                        revocable independently of both capture and files.
 *
 * Canon: docs/enhancements/ideation-capture-2026-05.md §A.4.
 */
export const SCOPES = ["ideation:write", "notes:write", "files:write", "graph:write"];
/** Type guard — narrows an arbitrary string to a known Scope. */
export function isScope(value) {
    return SCOPES.includes(value);
}
//# sourceMappingURL=scopes.js.map